@if (activeUser$ | async; as activeUser) {
  <app-header
    [activeUser]="activeUser"
    [title]="title"
    [subtitle]="subtitle"
  ></app-header>
}

<router-outlet />
<p-toast [baseZIndex]="999999"></p-toast>
